import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class ResourcesPeopleController extends Controller {
  @service router;
  @service intl;

  get tabs() {
    return [
      {
        label: 'dictionary.active',
        route: 'resources.people.active',
      },
      {
        label: 'dictionary.inactive',
        route: 'resources.people.inactive',
      },
    ];
  }

  @action
  extractRouteName(name) {
    if (!name.includes('index')) return name;
    else {
      const routeParts = name.split('.');
      routeParts.splice(routeParts.length - 1, 1);
      return routeParts.join('.');
    }
  }

  @action
  isActive(tab) {
    const currentRouteName = this.extractRouteName(
      this.router.currentRoute.name,
    );
    const tabRouteName = this.extractRouteName(tab.route);
    return currentRouteName === tabRouteName;
  }

  get activeTab() {
    const tab =
      this.tabs.filter((item) => this.isActive(item))?.[0] ?? this.tabs[0];
    return tab;
  }
}
